import { useQuery } from '@tanstack/react-query';
import { analyticsGetCircuitReports2 } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useCircuitReports = (year: number, quarter: number) =>
  useQuery({
    queryFn: async () =>
      extractData(analyticsGetCircuitReports2({ path: { year, quarter } })),
    queryKey: ['Analytics', 'CircuitReports', year, quarter],
  });
